import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-tipps',
  templateUrl: './tipps.component.html',
  styleUrls: ['./tipps.component.scss'],
})
export class TippsComponent implements OnInit {
  @Input() part: number;
  constructor() { }
  ngOnInit() {
    if(this.part === undefined){
      this.part = 1;
    }
  }


}
